import { render, staticRenderFns } from "./BlockAnimation.vue?vue&type=template&id=2068d0f9"
import script from "./BlockAnimation.vue?vue&type=script&lang=js"
export * from "./BlockAnimation.vue?vue&type=script&lang=js"
import style0 from "./BlockAnimation.vue?vue&type=style&index=0&id=2068d0f9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports